import { observable, action, makeObservable, autorun } from 'mobx';
import { sessionStorage } from 'js-storage';

class LocaleStore {
  constructor() {
    makeObservable(this);
  }

  @observable
  current: Locale = sessionStorage.get('guiconfig_locale') || 'en';

  @action.bound
  updateLocale(l: Locale) {
    this.current = l;
  }
}

const localeStore = new LocaleStore();

autorun(() => {
  sessionStorage.set('guiconfig_locale', localeStore.current);
});

export default localeStore;
